const FORBIDDEN_FALLBACK = 'You are not authorized to perform this action.';

/**
 * Text for a 403 that reached the caller: the interceptor only hands those over when the session is fine, so the
 * user is not allowed to do this. Prefers the message of the API (`message` or the FastAPI `detail`).
 *
 * @param {object} error The axios error
 * @returns {string}
 */
export function getForbiddenMessage(error) {
  const data = error?.response?.data;
  const detail = typeof data?.detail === 'string' ? data.detail : undefined;
  return data?.message || detail || FORBIDDEN_FALLBACK;
}
